import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-446d3f8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_2 = { class: "grid-container px-3" }
const _hoisted_3 = { class: "grid-box" }
const _hoisted_4 = { class: "card grid-add" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image fa-2x me-1" }, null, -1))
const _hoisted_7 = { class: "card grid-item" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-times" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "activityAttachmentImageModal",
    backdrop: "static"
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("จัดการรูปภาพประกอบ ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              ref: "fileDialog",
              type: "file",
              class: "file-upload",
              accept: "image/*",
              disabled: _ctx.isLoading,
              multiple: true,
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileDialogChange && _ctx.fileDialogChange(...args)))
            }, null, 40, _hoisted_5),
            _createElementVNode("div", {
              class: "card-body d-flex justify-content-center align-items-center px-0",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fileDialogOpen && _ctx.fileDialogOpen(...args)))
            }, [
              _hoisted_6,
              _createTextVNode("เพิ่มรูป ")
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "grid-box"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn delete-item",
                  title: "ลบ",
                  onClick: ($event: any) => (_ctx.deleteImage(image.id))
                }, _hoisted_11, 8, _hoisted_9),
                _createElementVNode("img", {
                  src: image.uri,
                  class: "image-content",
                  alt: "image"
                }, null, 8, _hoisted_12)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_14,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_13)
    ]),
    _: 1
  }, 512))
}